// extracted by mini-css-extract-plugin
module.exports = {"vGray3":"#dfe1fa","title":"UserProfileInfo_title__271rx","row":"UserProfileInfo_row__RJc4k","text":"UserProfileInfo_text__33ScX"};